import { SxProps } from '@mui/material';
import { black1 } from 'app/components/ThemeProvider/colors';

export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 32px 0 48px',
  height: '75px',
};

export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '100px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
  wordWrap: 'break-word',
};

export const tableHeaderCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '100px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
  wordWrap: 'break-word',

  // '&:nth-of-type(4)': {
  //   width: '100px',
  // },
  //'&:nth-of-type(5)': {
  //     width: '150px',
  //   },
  '&:nth-of-type(1)': {
    width: '100px',
  },
  '&:nth-of-type(2)': {
    width: '60px',
  },
  '&:nth-of-type(3)': {
    width: '120px',
  },
  '&:nth-of-type(4)': {
    width: '100px',
  },
  '&:nth-of-type(5)': {
    width: '270px',
  },
  //
  '&:nth-of-type(6)': {
    width: '130px',
  },
  '&:nth-of-type(7)': {
    width: '50px',
  },
};

export const tableBtnDownload: SxProps = {
  backgroundColor: 'rgba(0, 119, 214, 1)',
  height: '41px',
  '&:hover': {
    backgroundColor: 'rgba(0, 102, 185, 1)',
  },

  fontSize: '13px',
  color: 'white',
  lineHeight: '1',
  fontWeight: 600,
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  p: '12px 16px',
  borderRadius: '6px',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const tableBtnLook: SxProps = {
  backgroundColor: 'transparent',
  height: '41px',
  border: '1px solid rgba(20, 25, 31, 0.16)',
  borderRadius: '6px',
  p: '12px 16px',
  '&:hover': {
    backgroundColor: 'rgba(20, 25, 31,  0.10)',
  },
};

export const tableCellText: SxProps = { fontSize: '15px', color: black1, lineHeight: '1', fontWeight: 600 };
